const ru = {
  genderTxt: 'Гендер',
  gender: 'Мужской',
  ageTxt: 'Возраст',
  heightTxt: 'Рост',
  weightTxt: 'Вес',
  occupationTxt: 'Профессия',
};

export default ru;
